import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { IFilters } from '@shared/interfaces/filters.interface';
import { PrimeNGConfig } from 'primeng/api';
import { bookingsListMock } from 'src/mocks/bookings-fake.mock';
import { BookingService } from '@shared/services/booking.service';
import { ICapacity } from '@shared/interfaces/capacity.interface';
import { PlanningService } from '../services/planning.service';
import { parse } from 'date-fns';
import { ApiService } from '@shared/services/api.service';


@Component({
  selector: 'app-toolbar-sub',
  templateUrl: './toolbar-sub.component.html',
  styleUrls: ['./toolbar-sub.component.scss']
})
export class ToolbarSubComponent implements OnInit{

  @Input() filter!: IFilters;
  // @Output() optionSelectionChanged = new EventEmitter<{ offices: string[], services: string[] }>();
  @Output() applyFilterClicked = new EventEmitter<void>();

  public toolbarData = bookingsListMock;
  public listOffices: string[] = [];
  public listServices: string[] = []; 
  public listCapacity: ICapacity[] = [];
  public selectedOffice: string[] = [];
  public selectedService: string[] = [];
  public selectedCapacity: ICapacity[] = [];
  public rangeDates: Date[] | null = null;
  public dateToday: Date = new Date();
  public selectAll: boolean = false;
  public bookingServices: any = [];

  constructor(
    private config: PrimeNGConfig, 
    private bookingService: BookingService, 
    public planningService: PlanningService, 
    public apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.selectAll = true;

    this.config.setTranslation({
      clear: 'Borrar',
      today: 'Hoy',
      firstDayOfWeek: 1,
      dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
      monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
    });



    this.apiService.getOffices().subscribe((offices: any) => {
      this.listOffices = offices;
    });

    this.apiService.getServicesList().subscribe((services: any) => {
      this.listServices = services;

    });

    this.apiService.getUserAuth().subscribe((user: any) => {

      let office_id = user.office_id;
      this.selectedOffice = this.listOffices.filter((office: any) => office.id == office_id);
      this.optionsSelectionChange();
      let todayDay = new Date();
      let nextDay: any = new Date();
      nextDay.setDate(nextDay.getDate() + 1);

      this.rangeDates = [todayDay, nextDay];
    });



    let listCapacitySet: Set<any> = new Set();
    let listCapacityArray: any[] = [];

    // this.listCapacity = [
    //   { name: 'Individual', value: 1 },
    //   { name: '2 personas', value: 2 },
    //   { name: '3 personas', value: 3 },
    //   { name: '4 personas', value: 4 },
    //   { name: 'grupo', value: 5 },
    // ];
    
    this.planningService.filteredPlanningDataGet.subscribe((bookingServices: any) => {
      this.bookingServices = bookingServices;

 

    });
    this.apiService.getBookingServicesPlanning().subscribe((bookignServices: any) => {
      bookignServices.forEach((bookingService: any) => {
        listCapacitySet.add(bookingService.units);
      });
  
      listCapacityArray = Array.from(listCapacitySet).sort(function(a: any, b: any) {
          return a - b;
      });
      listCapacityArray.forEach((capacity: any) => {
        if(capacity == 1){
          this.listCapacity.push({name: 'Individual', value: capacity});
        }else{
          this.listCapacity.push({name: capacity+' Personas', value: capacity});
        }
      });
    });



  }
  
  optionsSelectionChange(event?: any){
  
    this.planningService.rangeDates = this.rangeDates;
    this.planningService.selectedOffice = this.selectedOffice;
    this.planningService.selectedService = this.selectedService;
    this.planningService.selectedCapacity = this.selectedCapacity;

    this.planningService.filterPlanningResult();
  }


  clearFilters() {
    this.selectedOffice = [];
    this.selectedService = [];
    this.selectedCapacity = [];
    this.rangeDates = null;
    
    this.planningService.selectedOffice = [];
    this.planningService.selectedService = [];
    this.planningService.selectedCapacity = [];
    this.planningService.rangeDates = null;

    const selection = {
      offices: this.selectedOffice,
      services: this.selectedService,
      seats: this.selectedCapacity.map(seats => seats.value),
      date: this.rangeDates ? [...this.rangeDates] : []
    };
  
    // this.optionSelectionChanged.emit(selection);
    this.bookingService.updateCombinedSelection(selection);
  }
  
  
}
